import FolderCreateService from '../../files/FolderCreateService'
import { OperationContext, OperationSpec } from './OperationContext'
import { RunnableOperation } from './RunnableOperation'

export class RunnableFolderPut extends RunnableOperation {
  private folderCreateService: FolderCreateService | null = null
  private abortController: AbortController | null = null

  constructor(userOpSpec: OperationSpec) {
    super(userOpSpec)
    this.abortController = new AbortController()
  }

  async defineRequest(context: OperationContext): Promise<void> {
    super.defineRequest(context)
    const isEncryptedZone = !!this.userOpSpec.isEncryptedZone
    console.log(
      '🚀 ~ RunnableFileUpload ~ defineRequest ~ isEncryptedZone:',
      isEncryptedZone
    )
    return Promise.resolve()
  }

  async execute(): Promise<void> {
    this.setStatus('running')
    if (this.aborted) {
      throw new Error('Operazione interrotta')
    }

    try {
      this.folderCreateService = new FolderCreateService()
      this.folderCreateService.onProgressUpdate = (progress: number) => {
        this.setProgress(progress)
      }
      await this.folderCreateService.createFolder(
        this.userOpSpec,
        this.abortController?.signal
      )
      console.log('File eliminato con successo')

      this.setStatus('completed')
    } catch (error) {
      if ((error as Error).name === 'AbortError') {
        this.setStatus('aborted')
      } else {
        this.setStatus('error')
        console.error("Errore durante l'upload del file:", error)
        throw error
      }
    }
  }

  abort(): void {
    if (this.abortController) {
      this.abortController.abort()
    }
    if (this.folderCreateService) {
      this.folderCreateService.abortOperation()
    }
    super.abort()
  }
}
